import React, { MouseEvent, useEffect } from 'react'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { MessageTypeConfiguration } from './MessageTypeForm'
import { BaseNodeProps } from '../../base/types'

const MessageTypeNode = React.memo(
  ({ data, isConnectable }: BaseNodeProps<MessageTypeConfiguration>) => {
    const title = 'Message Type'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'filter'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default MessageTypeNode
